export {default} from './Notes.connect';
